import { IPage, IPageView } from "../models";

import { DataContextProvider } from "./DataContextProvider";
import { PageDataContextInitializer } from "./PageDataContextInitializer";

export const PageDataContextProvider = ({ page, pageView, children }: {
    page: IPage,
    pageView: IPageView,
    children?: React.ReactNode
}) => {
    return <>
        <DataContextProvider>
            <PageDataContextInitializer page={page} pageView={pageView} />
            {children}
        </DataContextProvider>
    </>
}